import { http, uploadFile } from '@/utils/axios'

/**
 * @msg: 获取签到/签退二维码
 */
export function getQrCode(data) {
    return http({
        url: http.baseUrl('zkolQrCode/getQrCode'),
        method: 'post',
        params: http.params(data)
    })
}
/**
 * @msg: 获取签到签退人数
 */
export function getSignRecordCount(data) {
    return http({
        url: http.baseUrl('zkolSignRecord/getSignRecordCount'),
        method: 'post',
        params: http.params(data)
    })
}
/**
 * @msg: 获取签到签退人数
 */
export function getSignOutRecordCount(data) {
    return http({
        url: http.baseUrl('zkolSignOut/getSignOutCount'),
        method: 'post',
        params: http.params(data)
    })
}
/**
 * @msg: 考勤记录
 */
export function getSignList(data) {
    return http({
        url: http.baseUrl('zkolSignRecord/getSignList'),
        method: 'get',
        params: http.params(data)
    })
}